import { NavLink } from "react-router-dom";

import type { SurveyDetailRoute } from "~/features/surveys/lib/survey-detail-routes";
import { getSurveyDetailPath } from "~/features/surveys/lib/survey-detail-routes";
import { useTranslation } from "~/i18n";
import { cn } from "~/utils";

interface SurveyDetailNavigationLinkProps {
  indented?: boolean;
  onNavigate?: () => void;
  route: SurveyDetailRoute;
  surveyUuid: string;
}

export const surveyDetailNavigationItemClassName =
  "flex min-h-12 w-full items-center rounded-lg px-3 text-sm font-medium transition-colors hover:bg-white/30 hover:text-foreground focus-visible:bg-white/30 focus-visible:text-foreground focus-visible:outline-none lg:min-h-[45px] lg:px-0 lg:text-lg lg:font-extrabold lg:leading-9";

export function SurveyDetailNavigationLink({
  indented = false,
  onNavigate,
  route,
  surveyUuid,
}: SurveyDetailNavigationLinkProps) {
  const { t } = useTranslation();

  return (
    <NavLink
      to={getSurveyDetailPath(surveyUuid, route)}
      end
      onClick={onNavigate}
      className={({ isActive }) =>
        cn(
          surveyDetailNavigationItemClassName,
          isActive ? "bg-white/30 text-foreground" : "text-white",
        )
      }
    >
      <span className={indented ? "ml-6 lg:ml-[51px]" : "lg:ml-6"}>
        {t(route.labelKey)}
      </span>
    </NavLink>
  );
}
